import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'sq' ? 'en' : 'sq';
    i18n.changeLanguage(newLang);
    localStorage.setItem('i18nextLng', newLang); // Ensure it's saved
  };

  const currentLangLabel = i18n.language === 'sq' ? 'AL' : 'EN';
  const nextLangLabel = i18n.language === 'sq' ? 'EN' : 'AL';

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={toggleLanguage}
      className="flex items-center gap-2 border-2"
    >
      <Globe className="w-4 h-4" />
      <Badge variant="default" className="font-bold">
        {currentLangLabel}
      </Badge>
      <span className="text-xs text-muted-foreground">→ {nextLangLabel}</span>
    </Button>
  );
};